import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const SubNavHeader = styled(Link)`
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  justify-content: left;
  align-items: center;
  height: 60px;
  padding: 1rem;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const StyledSideBarLink = styled(Link)`
  color: ${({ theme }) => theme.baseBlue.a6};
  cursor: pointer;
  ${media.tablet`
    pointer-events: none;
    cursor: default;
  `}
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const NavItemWithIcon = styled(Link)<{$isItemScales?: boolean}>`
  color: ${({ theme }) => theme.baseBlue.a6};
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 1rem;
  padding-left: ${({$isItemScales}) => ( $isItemScales ? '1.3rem' : '1rem')};
  ${media.tablet`
    pointer-events: none;
    cursor: default;
  `}
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const TimeLeft = styled.span`
  color: ${({ theme }) => theme.red.a10};
`;

export const SurveyName = styled.span<{ $selected?: boolean }>`
  cursor: pointer;
  color: ${({ theme, $selected }) => ($selected ? theme.baseBlue.a10 : theme.baseBlue.a6)};
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const PullRight = styled.div`
  float: right;
  margin-top: 5px;
`;

export const SubnavCircle = styled.span`
  font-weight: 900;
  line-height: 1.73;
`;

export const SubNavLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 1.4rem;
`;

export const SubNavSection = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
`;

export const SubNavItem = styled.div<{ $withDueDate?: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  min-height: ${({ $withDueDate }) => ($withDueDate ? '80px' : '45px')};
  text-decoration: none;
  background-color: ${({ theme }) => theme.white.a10};
  overflow: hidden;
  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.baseBlue.a10};
  }
  a:focus {
    text-decoration: none !important;
  }
`;

export const SubNavItemLinkText = styled.div`
  padding: 0.5rem 1rem;
  text-decoration: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.white.a10};
  z-index: 1;
  position: relative;
  line-height: 25px;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const ItemText = styled.div`
  padding-left: 0.5rem;
  text-decoration: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.white.a10};
  z-index: 1;
  position: relative;
  line-height: 25px;
  &::first-letter {
    text-transform: capitalize;
  }
`;

export const SubTitle = styled.span`
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const SubCycleLink = styled(Link)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const CycleSubNavItem = styled.span<{ $selected: boolean }>(
  ({ theme, $selected }) => css`
    color: ${$selected ? theme.baseBlue.a10 : theme.baseBlue.a6};
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    &:hover {
      text-decoration: none;
      color: ${theme.baseBlue.a10};
    }
    /* stylelint-disable-next-line no-descending-specificity */
    a {
      color: ${$selected ? theme.baseBlue.a10 : theme.baseBlue.a6};
      text-decoration: none;
      &:hover {
        color: ${theme.baseBlue.a10};
      }
      &:active {
        text-decoration: none;
      }
      &:focus {
        text-decoration: none !important;
      }
    }
  `,
);

export const ProgressBar = styled.div<{ $optionsLength: number }>(
  ({ theme, $optionsLength }) => css`
    height: ${$optionsLength * 35}px;
    width: 3px;
    background-color: ${theme.black.a1};
    overflow: hidden;
  `,
);

export const ProgressbarStatus = styled.div<{ $status: null | number; $optionsLength: number }>`
  height: ${({ $optionsLength }) => 100 / $optionsLength}%;
  width: 2px;
  margin-top: ${({ $status }) => ($status === null ? -36 : $status * 35)}px;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  transition: margin-top 0.3s ease;
`;

export const SubNavItemHeader = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  padding: 1rem;
  font-weight: 400;
  cursor: pointer;
  font-size: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const CycleHeader = styled(SubNavItemHeader)`
  border-bottom: none;
`;

export const SpinnerContainer = styled.div`
  padding: 30px;
`;

export const CycleSectionHeader = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.67;
  letter-spacing: 1.25px;
  padding-top: 15px;
  padding-bottom: 5px;
  margin-left: 15px;
  color: rgba(41, 44, 56, 0.4);
`;

export const CyclesContainer = styled.div`
  min-height: 5px;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;

export const RefreshWrapper = styled.div`
  opacity: 0.5;
  width: 20px;
  height: 20px;
  display: flex;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

export const CycleSubMenuContainer = styled.div<{ $open: boolean; $length: number }>(
  ({ $open, $length, theme }) => css`
    padding: 0 1.1rem 1.1rem 1.1rem;
    display: ${$open ? 'flex' : 'none'};
    flex-direction: row;
    z-index: 0;
    margin-top: ${$open ? '0' : -($length + 1) * 45}px;
    transition: margin-top 235ms cubic-bezier(0.4, 0, 0.2, 1);
    &.entering,
    &.exiting,
    &.entered {
      display: flex !important;
    }
    ul {
      margin-left: 15px;
      width: 100%;
    }
    li {
      line-height: 1.73;
      color: ${theme.baseBlue.a6};
      padding: 5px 0;
      width: 100%;
      &:hover {
        color: ${theme.baseBlue.a10};
      }
    }
  `,
);
